import * as React from "react"
import { Route, Switch } from "react-router-dom"
import { type DigitsRoute } from "@digits-shared/components/Router/DigitsRoute"
import { LoggedRedirect } from "@digits-shared/components/Router/LoggedRedirect"
import useSession from "@digits-shared/hooks/useSession"
import { ApplicationFullWidthPane } from "src/frontend/components/OS/Chrome/Desktop/ApplicationPane"
import type FrontendSession from "src/frontend/session"
import useIntervalOrigin from "src/shared/hooks/useIntervalOrigin"

/*
 STYLES
*/

/*
 INTERFACES
*/

interface ChromeProps {
  Header: React.FC
  fallThrough: DigitsRoute
}

/*
 COMPONENTS
*/

export const AnalysisMobileChrome: React.FC<React.PropsWithChildren<ChromeProps>> = ({
  Header,
  children,
  fallThrough,
}) => {
  const session = useSession<FrontendSession>()
  const intervalOrigin = useIntervalOrigin()
  const intervalOriginNoCount = { ...intervalOrigin }
  delete intervalOriginNoCount.intervalCount

  const redirectParams = { leSlug: session.currentLegalEntity.slug, ...intervalOriginNoCount }

  return (
    <ApplicationFullWidthPane>
      <Header />
      <Switch>
        {children}

        {/* Catch any fall through routes and redirect accordingly */}
        <Route
          path={fallThrough.parameterizedPath}
          render={() => (
            <LoggedRedirect
              name="AnalysisMobileChrome-FallThrough"
              to={fallThrough.generate(redirectParams)}
            />
          )}
        />
      </Switch>
    </ApplicationFullWidthPane>
  )
}
